import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authenticate',
  template: ''
})
export class AuthenticateComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.generateGoogleAuthUrl().subscribe(resGoogleAuthUrl => {
      if (resGoogleAuthUrl.status === 'verified') {
        window.location.href = 'http://localhost:4300/helpdesk/ticket-view/all';
      } else if (resGoogleAuthUrl.status === 'unverified') {
        window.location.href = resGoogleAuthUrl.auth_url;
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
  }

}
